import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { FileService } from './services/file.service';
import { DialogModule } from 'primeng/primeng';
// import { JwtHelper } from 'angular2-jwt';
import { Observable, Subscription } from 'rxjs';
import { IsAdmin } from './guards/isAdmin';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { FreshdeskComponent } from './components/freshdesk/freshdesk.component';
import { AppInsightsService } from 'ng2-appinsights';
import { BroadcastService, MsalService } from '@azure/msal-angular';
import { User } from 'msal';
import { environment } from '../environments/environment.prod';
// import { BroadcastService } from '@azure/msal-angular';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [FileService]
})
export class AppComponent implements OnInit, OnDestroy {

  constructor(
    private _adminGuard: IsAdmin,
    private _router: Router,
    private _aiService: AppInsightsService,
    private _loginBroadcast: BroadcastService,
    private _msalService: MsalService
  ) { }
  private _subscription: Subscription;
  private _user: User;
  public isAdmin: boolean;
  public showDownloads = false;

  ngOnInit(): void {
    // Initialize the App Insights Service
    this._aiService.Init(environment.applicationInsights);

    this._user = this._msalService.getUser();
    const user = this._user;
    if (user) {
      this._aiService.setAuthenticatedUserContext(user.idToken['signInNames.emailAddress']);
    }

    // console.log(this._user);
    // console.log(user.idToken["signInNames.emailAddress"]);

    let w: any;
    w = window;
    const appInsights = w.appInsights;

    appInsights.queue.push(function () {
      appInsights.context.addTelemetryInitializer(function (envelope) {
        const telemetryItem = envelope.data.baseData;

        // if (telemetryItem.exceptions && telemetryItem.exceptions.length>0){
        //   var exception = telemetryItem.exceptions[0];
        //   //we think this may not be a real error
        //   if (exception.message.includes("No JWT present or has expired")){
        //     return false;
        //   }
        // }

        // // To set custom properties:
        telemetryItem.properties = telemetryItem.properties || {};
        if (user != null) {
          telemetryItem.properties['user'] = user.idToken['signInNames.emailAddress'];
        }

      });
    });


    this._router.events.subscribe((e: NavigationStart) => {
      if (e instanceof NavigationStart && e.url !== '/') {
        this._adminGuard.canActivate().subscribe(a => this.isAdmin = a);
      }
      if (e instanceof NavigationStart && e.url.startsWith('/downloads')) {
        this.showDownloads = true;
      }
    });

    // this._loginBroadcast.subscribe("msal:loginSuccess", (payload) => {
    //     console.log(payload);
    // });

    this._subscription = this._loginBroadcast.subscribe('msal:loginFailure', (payload) => {
      if (payload.errorDesc != null && payload.errorDesc.startsWith('AADB2C90118')) {// password reset
        const currentLocation = encodeURIComponent(window.location.href.replace(window.location.hash, ''));
        // tslint:disable-next-line:max-line-length
        window.location.href =
          'https://geoinsightsbtc.b2clogin.com/geoinsightsbtc.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_PasswordReset&client_id=671488aa-7088-4591-9aba-698d56a10fc3&nonce=defaultNonce&redirect_uri='
          + currentLocation + '&scope=openid&response_type=id_token&prompt=login';
      }
      if (payload.errorDesc != null && payload.errorDesc.startsWith('AADB2C90091')) {// cancel password reset
        window.location.href = window.location.origin;
      }
      // console.log(payload);
    });
  }

  ngOnDestroy() {
    this._loginBroadcast.getMSALSubject().next(1);
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }
}





// WEBPACK FOOTER //
// ./src/app/app.component.ts